module.exports = __webpack_public_path__ + "static/media/deadly-5.6ad79dba.png";